import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import RepackagingPopup from "./rePackingOrder";
import { getAddressesByUserId } from "../../redux/reducer/userAddressReducer";
import BoxEmpty from "./boxEmpty";
import { fetchMyCarts } from "../../redux/reducer/cartReducer";
import LoadingSpinner from "../animation/LoadingSpinner";
import CartPackaging from "./CartPackaging";

const ListOfBoxCardOrders = ({ selectedMenuItem, onMenuItemClick }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { carts, cartsLoading, cartsError } = useSelector((state) => state.carts);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    dispatch(fetchMyCarts());
    dispatch(getAddressesByUserId());
  }, [dispatch]);

  const handleClosePopup = () => {
    setSelectedOrder(null);
  };

  
  if (cartsLoading) {
    return <LoadingSpinner />;
  }

  const beforeReceivedCarts = carts?.filter(
    (cart) => cart.status === "received"
  ) || [];

  const TurkeyReceivedCarts = beforeReceivedCarts.filter(
    (cart) => cart.area === "67dfef4a100f542a2c700c04"
  );
  const EuropeReceivedCarts = beforeReceivedCarts.filter(
    (cart) => cart.area === "67dfef98100f542a2c700c08"
    
  );
  // console.log(beforeReceivedCarts)
  
    const PaidCarts = carts?.filter((item) =>
    (item.status?.toLowerCase() === "received" && item.isPacking && item.isReadyToPaid) 
    ||
    (item.status?.toLowerCase() === "received" &&  !item.isPacking)
  );

  if(beforeReceivedCarts.length ===0 || cartsError){
    return <BoxEmpty  title="EmptyBox"/>
  }



// console.log(carts)
// console.log(TurkeyReceivedCarts)
// console.log(EuropeReceivedCarts)
  return (
    <div>
      {carts?.some((cart) => cart.status === "received") ? (
        <div className="flex justify-center gap-4 mb-6">
          <button
            className={`lg:text-lg px-6 py-3 font-bold text-sm focus:outline-none transition-colors ${
              selectedMenuItem === "ListOfBoxCardOrders" ? "bg-custom-yellow text-black" : "bg-white text-black"
            }`}
            onClick={() => onMenuItemClick("ListOfBoxCardOrders")}
          >
            {t("Repackaging")}
          </button>
          {PaidCarts?.length > 0 ?
            <button
              className={`lg:text-lg text-sm px-6 py-3 font-bold  focus:outline-none transition-colors ${
                selectedMenuItem === "ListOfBoxShipmentOrders" ? "bg-custom-yellow text-black" : "bg-white text-black"
              }`}
              onClick={() => onMenuItemClick("ListOfBoxShipmentOrders")}
            >
              {t("startShimpment")}
            </button>
            :
            <>
            </>
          }
        </div>
      ):
      (
        null
      )}
     

      {/* Turkey */}
      <CartPackaging carts={TurkeyReceivedCarts} />



      {/* Europe */}
      <CartPackaging carts={EuropeReceivedCarts}/>

    

 
      {selectedOrder && <RepackagingPopup order={selectedOrder} onClose={handleClosePopup} />}
    </div>
  );
};

export default ListOfBoxCardOrders;
